// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeIdPlanCodePairDto
 */
export interface IEmployeeIdPlanCodePairDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeIdPlanCodePairDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeIdPlanCodePairDto
     */
    plan_code: string;
}

/**
 * Check if a given object implements the IEmployeeIdPlanCodePairDto interface.
 */
export function instanceOfIEmployeeIdPlanCodePairDto(value: object): value is IEmployeeIdPlanCodePairDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('plan_code' in value) || value['plan_code'] === undefined) return false;
    return true;
}

export function IEmployeeIdPlanCodePairDtoFromJSON(json: any): IEmployeeIdPlanCodePairDto {
    return IEmployeeIdPlanCodePairDtoFromJSONTyped(json, false);
}

export function IEmployeeIdPlanCodePairDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeIdPlanCodePairDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'plan_code': json['plan_code'],
    };
}

export function IEmployeeIdPlanCodePairDtoToJSON(json: any): IEmployeeIdPlanCodePairDto {
    return IEmployeeIdPlanCodePairDtoToJSONTyped(json, false);
}

export function IEmployeeIdPlanCodePairDtoToJSONTyped(value?: IEmployeeIdPlanCodePairDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'plan_code': value['plan_code'],
    };
}

